import React, {useEffect, useState} from 'react';
import {Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger} from "../dialog/dialog";
import {Button} from "../primitives/button/button";
import {Input} from "../primitives/imput/input";
import {Checkbox} from "../primitives/checkbox/checkbox";
import {useConsentStore} from "../../../lib/store/consent-store";
import {IMaskInput} from "react-imask";
import {cn} from "../../../lib/utils";
import {useSendForm} from "../../../lib/hooks/use-send-form";


interface DialogFormProps {
  children: React.ReactNode;
  title: string
  subtitle?: string
  disclaimer?: string
  disclaimerTitle?: string
  actionBtnText?: string
  celtype: string
}

export const DialogForm = ({
                             children,
                             title,
                             subtitle,
                             disclaimerTitle,
                             disclaimer,
                             actionBtnText = 'Заказать звонок',
                             celtype
                           }: DialogFormProps) => {
  const consent = useConsentStore(state => state.consent);
  const updateConsent = useConsentStore(state => state.updateConsent);

  const [termsChecked, setTermsChecked] = useState(false);
  const [termsError, setTermsError] = useState(false)
  const [fieldsError, setFieldsError] = useState(false)

  const [success, setSuccess] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    text: title
  })

  useEffect(() => {
    setFieldsError(false)
  }, [formData])

  useEffect(() => {
    setTermsError(false)
  }, [termsChecked]);

  const handleInputChange = (value: string, name: string) => {
    setFormData({...formData, [name]: value})
  }

  const validateFormAndSend = () => {
    if (formData.name === '' || formData.phone === '') {
      setFieldsError(true)
      return
    }

    if (!termsChecked) {
      setTermsError(true)
      return
    }

    sendForm(formData, celtype, () => {
      setSuccess(true)
    })
  }

  const {sendForm, isPending, error} = useSendForm()

  return (
    <Dialog>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="px-[50px] font-open-sans py-8">
        <DialogHeader>
          {subtitle && <span className='bg-plt-secondary rounded-full text-plt-white py-1 px-5'>
            {subtitle}
          </span>}
          <DialogTitle className="font-bold text-xl font-open-sans">
            {title}
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-1 mt-4">
          <Input name='name' value={formData.name} onChange={(e) => handleInputChange(e.target.value, 'name')}
                 placeholder="Ваше имя" className="rounded-[5px] h-8"/>
          <IMaskInput name='phone' value={formData.phone} onAccept={(value) => handleInputChange(value, 'phone')}
                      mask={'+7 (000) 000-00-00'} placeholder={'Ваш телефон'} className={cn(
            'ym-record-keys placeholder:text-plt-dark-gray selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-plt-gray flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
            'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
            'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
            'rounded-[5px] h-8'
          )}/>
          <Button disabled={isPending} type='submit'
                  onClick={() => validateFormAndSend()}
                  className="font-bold rounded-[5px] h-8">
            {actionBtnText}
          </Button>
          {termsError &&
              <p className='text-xs text-red-500'>Пожалуйста, дайте согласие на обработку персональных данных</p>}
          {fieldsError && <p className='text-xs text-red-500'>Пожалуйста, заполните все поля перед отправкой</p>}
        </div>
        {success &&
            <p className='py-3 rounded text-center text-xs text-green-500 border border-solid border-green-500'>Форма
              успешно
              отправлена, спасибо!</p>}
        <div className="flex items-center gap-2">
          <Checkbox checked={termsChecked} onCheckedChange={(checked) => setTermsChecked(checked === true)}
                    id="call-terms" className="border-plt-dark-gray"/>
          <label
            htmlFor="call-terms"
            className="text-plt-dark-gray text-[10px] leading-[120%]"
          >
            Нажимая кнопку «Оставить заявку», вы даете согласие на
            обработку персональных данных и соглашаетесь с политикой
            конфиденциальности
          </label>
        </div>
        <div className="flex items-center gap-2">
          <Checkbox id={'form-consent'}
                    checked={consent}
                    onCheckedChange={(checked) => updateConsent(checked === true)}
                    className="border-plt-dark-gray"/>
          <label className="text-plt-dark-gray text-[10px] leading-[120%]" htmlFor='form-consent'>
            Я ознакомлен (-на) с правилами обработки куки
          </label>
        </div>
        {disclaimerTitle &&
            <Dialog>
              <DialogTrigger className='underline text-xs'>
                {disclaimerTitle}
              </DialogTrigger>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle className='sr-only'>
                    {disclaimerTitle}
                  </DialogTitle>
                </DialogHeader>
                <div>
                  {disclaimer}
                </div>
              </DialogContent>
            </Dialog>}

      </DialogContent>
    </Dialog>
  );
};
